// src/components/info/index.js
import React, { Component } from 'react'
import Logo from '../logo'
import './info.css'
import SubscribeForm from "react-mailchimp-subscribe";

class Info extends Component {

  componentDidMount() {
    this.requestData()
  }

  componentDidUpdate(prevProps) {
    const {
      match: prevMatch
    } = prevProps 
    const {
      match: nextMatch
    } = this.props 

    const prevActive = (prevMatch && prevMatch.isExact)
    const nextActive = (nextMatch && nextMatch.isExact)

    if (prevActive !== nextActive && nextActive) {
      this.requestData()
    }
  }

  // Request rows only if rows are empty
  // And active is set to true
  // Active is if route matches 
  requestData() {
    const { data, match, onRequestData } = this.props
    const active = (match && match.isExact)

    if (data) return
    if (!active) return
    
    onRequestData && onRequestData()
  }

  renderAddress(address) {
    return (address && address.size) ? 
    (
      address.map((loc, index) => (
        <div key={index} dangerouslySetInnerHTML={{ __html: loc.html }} />
      ))
    ) : null
  }

  renderDownload(download) {
    return (download && download.title && download.url) ?
    (
      <div>
        <a href={download.url} download>
          {download.title}
          &nbsp;
          <svg width="11px" height="14px" viewBox="0 0 11 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="download" transform="translate(-1.000000, 0.000000)" stroke="#FD3D2A">
                      <path d="M1.5,13.5 L11.5,13.5" id="line"></path>
                      <g id="arrow">
                          <g id="Group-2" transform="translate(6.500000, 5.792893) rotate(45.000000) translate(-6.500000, -5.792893) translate(2.500000, 1.792893)">
                              <path d="M0.964466094,6.5 L6.5,6.5" id="Line-2"></path>
                              <path d="M6.5,0.964466094 L6.5,6.5" id="Line-2"></path>
                          </g>
                          <path d="M6.5,0.5 L6.5,8.5" id="Line-2"></path>
                      </g>
                  </g>
              </g>
          </svg>
        </a>
      </div>
    ) : null
  }

  render() {
    const {
      download,
      description,
      address,
      vh,
     } = this.props
     
    const formProps = {
      action: "https://concreterep.us16.list-manage.com/subscribe/post?u=0c3483f71701645532651b592&id=1bc582a1dd",
      messages: {
        inputPlaceholder: "Join our Newsletter",
        btnLabel: "OK",
        sending: "sending...",
        success: "Thank you! Check your inbox.",
        error: "Please enter a valid email address!"
      },
      styles: {
        sending: {
          color: "#FD3D2A"
        },
        success: {
          color: "#FD3D2A"
        },
        error: {
          color: "#FD3D2A"
        }
      }
    }

    return (
      <div className="info">
        <div className="info__content" style={{ minHeight: vh }}>
          <div className="info__section info__description">
            {description}
          </div>
          <div className="info__section info__address">
            {this.renderAddress(address)}
          </div>
          <div className="info__section info__download">
            {this.renderDownload(download)}
          </div>
          <div className="info__newsletter_subscribe">
            <SubscribeForm {...formProps} />
          </div>
          <div className="info__section info__siteby">
            <p>SITE BY <a href="https://intmagic.com" target="_blank" title="INTERNATIONAL MAGIC" rel="noopener noreferrer">INTERNATIONAL MAGIC</a></p>
          </div>
        </div>
        <Logo colour={'#FD3D2A'} animate={false} active={true} />
      </div>
    )
  }
}

export default Info



// WEBPACK FOOTER //
// ./src/components/info/info.js